import { Provider } from "@models/interfaces";

export enum FinalizationTypes {
	MANUAL = "manual",
	EXTERNAL = "external"
}

export class PaymentOption extends Provider {
	private footnote: string = "";
	private summary_notification: string = "";
	private finalization_type: string = "";

	public isWebHandled(appUrl: string, redirectUrl: string): boolean {
		const prodUrl = "https://web.bitpanda.com/";
		const stagingUrl = "https://web.staging.waskurzes.com/";

		const checkUrl = (url: string): boolean => redirectUrl.startsWith(url);
		return (
			this.isExternal &&
			(checkUrl(appUrl) || checkUrl(window.origin) || checkUrl(prodUrl) || checkUrl(stagingUrl))
		);
	}

	public get isManual(): boolean {
		return this.finalization_type === FinalizationTypes.MANUAL;
	}

	public get isExternal(): boolean {
		return this.finalization_type === FinalizationTypes.EXTERNAL;
	}

	public get hasSupportedFinalizationType(): boolean {
		return Object.values(FinalizationTypes).includes(this.finalization_type as FinalizationTypes);
	}

	public getFootnote(): string {
		return this.footnote;
	}

	public getSummaryNotification(): string {
		return this.summary_notification;
	}

	public isLogoDescriptive(): boolean {
		if (this.isShortNameSepa()) {
			return false;
		}
		return this.is_logo_descriptive;
	}
}
